import "./App.css";
import { useRoutes } from "react-router-dom";
import { Login, Validate, Logout, Unauthorized, Home } from "./pages";
import Paths from "./paths";

function App() {
  let element;

  const routes = [
    { path: Paths.Base, element: <Login /> },
    { path: Paths.Login, element: <Login /> },
    { path: Paths.Home, element: <Home /> },
    { path: Paths.Logout, element: <Logout /> },
    { path: Paths.Validate, element: <Validate /> },
    { path: "*", element: <Unauthorized /> },
  ];

  const unauthorizedRoutes = [
    { path: Paths.Base, element: <Login /> },
    { path: Paths.Login, element: <Login /> },
    { path: Paths.Logout, element: <Logout /> },
    { path: Paths.Validate, element: <Validate /> },
    { path: "*", element: <Unauthorized /> },
  ];

  element = useRoutes(localStorage.hasOwnProperty('token') ? routes : unauthorizedRoutes);

  return <>{element}</>;
}

export default App;